import React, { useState } from "react";
import * as R from "ramda";
import { Query } from "react-apollo";
import { css } from "glamor";

import Button from "@arachnys/styleguide/Button";
import { withApolloState } from "@arachnys/flow-app/src/util/apollo";
import { GET_BULK_PERMISSIONS } from "../queries";
import BulkRequestPopup from "./BulkRequestPopup";

const styles = {
    bulkRequestButton: css({
        marginRight: 10,
    }),
    buttonContainer: css({
        display: "inline-block",
    }),
};

const UploadRequestButton = ({ onSuccess = () => {} }) => {
    const [bulkPopupOpened, setBulkPopupOpened] = useState(false);
    const togglePopup = state => () => setBulkPopupOpened(state);

    return (
        <Query query={GET_BULK_PERMISSIONS} fetchPolicy="cache-only">
            {withApolloState(({ data }) => {
                const canCreate = R.pathOr(
                    false,
                    ["ticketingPermissions", "bulkUploadRequest", "canCreate"],
                    data
                );

                return (
                    canCreate && (
                        <div className={styles.buttonContainer}>
                            <Button.Ghost
                                className={`${styles.bulkRequestButton}`}
                                onClick={togglePopup(true)}
                                size="large"
                            >
                                Batch Request
                            </Button.Ghost>
                            <BulkRequestPopup
                                visible={bulkPopupOpened}
                                onClose={togglePopup(false)}
                                onSuccess={onSuccess}
                            />
                        </div>
                    )
                );
            })}
        </Query>
    );
};

export default UploadRequestButton;
